import UrlParse from 'url-parse';

import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import ptBR from './pt-br.json';
import zh from './zh.json';

export const allLanguages = {
  de,
  en,
  es,
  fr,
  it,
  ja,
  ko,
  'pt-br': ptBR,
  zh
};

export const fallbackLanguage = 'en';

export const getDetectedLanguage = (win = window) => {
  let detectedLanguage;

  // check the setLng URL parameter
  const url = new UrlParse(win.location.href, true);
  if (url.query.setLng) {
    detectedLanguage = url.query.setLng.toLowerCase();
  }

  if (!detectedLanguage && typeof win.navigator !== 'undefined') {
    if (win.navigator.languages) {
      detectedLanguage = win.navigator.languages[0];
    } else if (win.navigator.language) {
      detectedLanguage = win.navigator.language;
    } else {
      detectedLanguage = win.navigator.userLanguage;
    }
  }

  // fallback
  if (!detectedLanguage) {
    detectedLanguage = fallbackLanguage;
  }

  return detectedLanguage;
};

export const detectedLanguage = getDetectedLanguage();

// find a language from a locale such as 'en' or 'en-US' or 'pt_br'
export const findLanguage = (locale = '') => {
  let entryKey = locale.toLowerCase().replace(/_/g, '-');
  let language = allLanguages[entryKey];

  if (!language) {
    entryKey = entryKey.split('-')[0];
    language = allLanguages[entryKey];
  }

  if (language) {
    return entryKey;
  }

  return '';
};
